import React from 'react'
import moment from 'moment'
import { COLORES } from '../../../../../../config/colores'
import TableValueAction from '../../../../../MuiTable/components/TableValueAction'
import InfoCpa from '../../../busquedaCpa/InfoCpa'

export function getColumnasRechazadosEnCalado (rol = null) {
  return ([
    {
      name: 'cartaDePorteAutomotor',
      label: 'Carta de porte',
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({
          style: {
            position: 'sticky',
            left: '0',
            background: COLORES.grey.light,
            zIndex: 100
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            left: 0,
            background: 'white',
            zIndex: 101
          }
        }),
        customBodyRender: (numero) => {
          return (
            <>
              {numero
                ? <TableValueAction
                  value={numero}
                  title=' '
                  content={<InfoCpa cpa={numero} />} />
                : null
              }
            </>
          )
        }
      }
    },
    {
      name: 'fechaDeCalado',
      label: 'Fecha de calado',
      options: {
        filter: true,
        sort: true,
        filterType: 'multiselect',
        customBodyRender: (fecha) => fecha ? <>{moment(fecha).format('DD-MM-YY HH:mm')}</> : null
      }
    },
    {
      name: 'cereal',
      label: 'Cereal',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox'
      }
    },
    {
      name: 'calificacionCereal',
      label: 'Calificación Cereal',
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: 'calificacionCerealDos',
      label: 'Calificación Cereal 2',
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: 'exportador',
      label: 'Exportador',
      options: {
        filter: true,
        sort: true,
        filterType: 'multiselect',
        display: !rol || (rol[0] !== 'EXPORTADOR' && rol[1] !== 'EXPORTADOR')
      }
    },
    {
      name: 'titularDeCupo',
      label: 'Titular de cupo',
      options: {
        filter: true,
        sort: true,
        display: !rol || (rol[0] !== 'CARGADOR' && rol[1] !== 'CARGADOR')
      }
    },
    {
      name: 'camion',
      label: 'Camión',
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: 'humedad',
      label: 'Humedad',
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: 'puestoDeCalado',
      label: 'Puesto de calado',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'detalle',
      label: 'Observaciones',
      options: {
        print: false,
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRender: () => {
          return (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                Rechazo no homogeneo
            </div>
          )
        }
      }
    }
  ])
}

export const COLUMNS_CAMIONES_RECHAZADOS_TO_PRINT = [
  {
    name: 'cartadeporte',
    label: 'Carta de porte',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'fechaDeCalado',
    label: 'Fecha de calado',
    width: 90,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'calificacionCereal',
    label: 'Calificación cereal',
    width: 100,
    mantenerCase: true
  },
  {
    name: 'calificacionCerealDos',
    label: 'Calificación cereal 2',
    width: 100,
    mantenerCase: true
  },
  {
    name: 'exportador',
    label: 'Exportador',
    width: 110,
    mantenerCase: true
  },
  {
    name: 'titularDeCupo',
    label: 'Titular de cupo',
    width: 90,
    mantenerCase: true
  },
  {
    name: 'camion',
    label: 'Camión',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'humedad',
    label: 'Humedad',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'puestoDeCalado',
    label: 'Puesto de calado',
    width: 80,
    mantenerCase: true
  }
]
